import { render, staticRenderFns } from "./FieldPolicyNumber.vue?vue&type=template&id=b5a971c6&"
import script from "./FieldPolicyNumber.vue?vue&type=script&lang=ts&"
export * from "./FieldPolicyNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5a971c6')) {
      api.createRecord('b5a971c6', component.options)
    } else {
      api.reload('b5a971c6', component.options)
    }
    module.hot.accept("./FieldPolicyNumber.vue?vue&type=template&id=b5a971c6&", function () {
      api.rerender('b5a971c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Leasing/FieldPolicyNumber.vue"
export default component.exports